import React, { useContext } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import routes from "../../routes/route";
import AuthContext from "../../../Auth/AuthContext";

const Sidebar = ({ isSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { apiProvider } = useContext(AuthContext);

  // Helper to check if a path is active, including query params
  const isPathActive = (path) => {
    // For home, check exact match
    if (path === routes.home) {
      return location.pathname === routes.home;
    }
    // For others, check if current URL starts with the path or matches exactly with query params
    const currentFullUrl = location.pathname + location.search;
    return currentFullUrl.startsWith(path);
  };

  return (
    <>
      <nav
        className={`sidebar sidebar-offcanvas ${isSidebarOpen ? "open" : ""}`}
        id="sidebar"
      >
        <ul className="nav">
          <li className={`nav-item ${isPathActive(routes.home) ? "active" : ""}`}>
            <NavLink
              to={routes.home}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
            >
              <span className="menu-title">Home</span>
              <i className="fi fi-sr-home menu-icon" />
            </NavLink>
          </li>

          <li className={`nav-item ${isPathActive(routes.games.topGames) ? "active" : ""}`}>
            <NavLink
              to={routes.games.topGames}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
            >
              <span className="menu-title">All Games</span>
              <i className="fi fi-sr-dice-alt menu-icon" />
            </NavLink>
          </li>

          <li className={`nav-item ${isPathActive("/filtered-games?type=card") ? "active" : ""}`}>
            <NavLink
              to="/filtered-games?type=card"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
            >
              <span className="menu-title">Live Casino</span>
              <i className="fi fi-rr-playing-cards menu-icon" />
            </NavLink>
          </li>

          <li className={`nav-item ${isPathActive(routes.pages.sportsbook.turboSports) ? "active" : ""}`}>
            <NavLink
              to={`${routes.pages.sportsbook.turboSports}?setIframePath=/cricket`}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={(e) => {
                e.preventDefault();
                sessionStorage.setItem("launchTurboSports", "true");
                navigate(`${routes.pages.sportsbook.turboSports}?setIframePath=/cricket`, {
                  state: { fromSidebar: true },
                });
              }}
            >
              <span className={`menu-title ${isSidebarOpen ? "d-flex align-items-center gap-2" : ""}`}>Cricket  <div className="live-badge">LIVE</div> </span>
              {/* <i className="fi fi-rs-tennis menu-icon" /> */}
              <i className="fi fi-rs-cricket menu-icon" />
            </NavLink>
          </li>

          <li className={`nav-item ${isPathActive("/filtered-games?type=crash") ? "active" : ""}`}>
            <NavLink
              to="/filtered-games?type=crash"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
            >
              <span className="menu-title">Crash Games</span>
              <i className="fa-solid fa-explosion menu-icon"></i>
            </NavLink>
          </li>
          {/* bonus */}
          <li className={`nav-item ${isPathActive(routes.games.bonus) ? "active" : ""}`}>
            <NavLink
              to={routes.games.bonus}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
            >
              <span className="menu-title">Referral</span>
              {/* <i className="fi fi-rs-memo-pad menu-icon" /> */}

              <i className="fi fi-rs-bonus-alt menu-icon"></i>
            </NavLink>
          </li>

          <li className={`nav-item ${isPathActive(routes.games.providers) ? "active" : ""}`}>
            <NavLink
              to={routes.games.providers}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
            >
              <span className="menu-title">Providers</span>
              <i className="fi fi-rs-clipboard menu-icon" />
            </NavLink>
          </li>

          <li className={`nav-item ${isPathActive(routes.pages.howToPlay) ? "active" : ""}`}>
            <NavLink
              to={routes.pages.howToPlay}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
            >
              <span className="menu-title">How to Play</span>
              <i className="fi fi-rr-interrogation menu-icon" />
            </NavLink>
          </li>

          <li className={`nav-item ${isPathActive(routes.pages.terms) ? "active" : ""}`}>
            <NavLink
              to={routes.pages.terms}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
            >
              <span className="menu-title">Terms and Conditions</span>
              <i className="fi fi-rs-memo-pad menu-icon" />
            </NavLink>
          </li>

          <li className={`nav-item ${isPathActive(routes.pages.privacyPolicy) ? "active" : ""}`}>
            <NavLink
              to={routes.pages.privacyPolicy}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
            >
              <span className="menu-title">Privacy and policy</span>
              <i className="fi fi-rs-clipboard menu-icon" />
            </NavLink>
          </li>
        </ul>
        <div className="br-top-gray"></div>
        <div className="min-menunone">
          <div className="container px-5">
            <Link to={routes.games.all}>
              <button
                type="button"
                className="btn swiper-scrollbar-drag w-100 bgbody-color text-white rounded-pill fs-15 fw-500"
              >
                All Games
              </button>
            </Link>
          </div>
          <div className="text-center  bottom-0 w-100 my-3 start-0">
            <div className="icon-social">
              <div className="d-flex justify-content-center  text-white fs-25 gap-3">
                <Link
                  to="https://www.facebook.com/Jiboomba"
                  target="new"
                  className="text-white"
                >
                  <i className="ri-facebook-fill" />
                </Link>
                <Link
                  to={"https://www.instagram.com/Jiboomba"}
                  target="new"
                  className="text-white"
                >
                  <i className="ri-instagram-line" />
                </Link>

                <Link
                  to={"https://x.com/Jiboomba"}
                  target="new"
                  className="text-white"
                >
                  <i className="ri-twitter-x-line" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
